import type {ComponentType} from 'react';

import {EditableLabel} from 'shells/editable-label/editable-label';

import {EditFieldWrapper} from './edit-field-wrapper';

import styles from './editable-label-field.module.css';

interface Props {
    icon: ComponentType<any>;
    label: string;
    value: string;
    editValue: string;
    placeholder: string;
    tooltip: string;
    onSaveNewValue: (value: string) => Promise<any>;
}

export function EditableLabelField(props: Props) {
    return (
        <EditFieldWrapper
            icon={props.icon}
            label={props.label}
            children={
                <div className={styles['label-field-container']}>
                    <EditableLabel
                        value={props.value}
                        editValue={props.editValue}
                        onSaveNewValue={props.onSaveNewValue}
                        placeholder={props.placeholder}
                        allowSavingEmpty={false}
                        shouldAllowUndo={false}
                        shouldTruncate={true}
                        tooltip={props.tooltip}
                        variant='header'
                    />
                </div>
            }
        />
    );
}
